(function () {
  const SELECTORS = [
    '.price-item',
    '.unit-price',
    '.cart-item__final-price',
    '.cart-item__old-price',
    '.cart-item__discounted-prices',
    '.totals__total-value',
    '.totals__subtotal-value',
    '.cart__discount',
    '.product__price',
    '[data-cart-subtotal]',
    // macade-custom-products + macade-recently-viewed-products
    '.related-items h5.subdued',
    // EliteCart upsell mini-cart (app-rendered)
    '.ec-lineitem-linetotal-price',
    '.ec-lineitem-price',
    '.ec-upsell-price',
    '.ec-cart-total',
  ].join(',');

  // Shopify's money filter can use regular, non-breaking ( ) or narrow
  // no-break ( ) spaces as thousand separators depending on locale.
  const SEP_CLASS = '\\s\\u00a0\\u202f.,';
  const NUMBER_RE = new RegExp('\\d[\\d' + SEP_CLASS + ']*\\d', 'g');
  const SEP_RE = new RegExp('[' + SEP_CLASS + ']', 'g');

  function stripPriceFormatting(text) {
    return text.replace(NUMBER_RE, (match) => {
      const noDecimals = match.replace(/[.,]\d{1,2}$/, '');
      return noDecimals.replace(SEP_RE, '');
    });
  }

  function cleanElement(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const next = stripPriceFormatting(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function clean(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SELECTORS)) cleanElement(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTORS).forEach(cleanElement);
  }

  function init() {
    clean(document.body);
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'characterData') {
          // Apps (e.g. EliteCart) sometimes update prices by writing to
          // textContent of an existing span — that's a characterData mutation,
          // not childList, so we re-clean the nearest matching ancestor.
          const parent = m.target.parentElement;
          const ancestor = parent && parent.closest(SELECTORS);
          if (ancestor) cleanElement(ancestor);
          continue;
        }
        m.addedNodes.forEach((n) => {
          const parent = n.nodeType === 1 ? n : n.parentElement;
          const ancestor = parent && parent.closest && parent.closest(SELECTORS);
          if (ancestor) cleanElement(ancestor);
          clean(n);
        });
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
